import { useAccountContext } from '@/features/workspaces/useAccountContext';
import { useAuth } from '@/lib/auth/auth';
import { useWorkspaceMode } from '@/features/workspaces/useWorkspaceMode';
import { Redirect } from 'expo-router';

export default function Index() {
  const session = useAuth((state) => state.session);
  const isHydrating = useAuth((state) => state.isHydrating);
  const workspaceMode = useWorkspaceMode();
  const { currentContext, isHydrating: isAccountContextHydrating } = useAccountContext();

  if (isHydrating || isAccountContextHydrating) {
    return null;
  }

  if (session) {
    if (
      workspaceMode.orgAccessEnabled &&
      currentContext?.kind === 'business' &&
      currentContext.activeOrgId
    ) {
      return <Redirect href={'/(business)/home' as any} />;
    }

    return <Redirect href="/(tabs)/events" />;
  }

  return <Redirect href="/(tabs)/events" />;
}
